export const notificationTypes = {
  ERROR: 'error',
  SUCCESS: 'success',
}
